/*
 * @Author: lidan
 * @Date: 2020-11-13 11:45:58
 * @LastEditTime: 2021-06-23 16:09:54
 * @LastEditors: Please set LastEditors
 * @Description: 司机费用上报明细
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\driverFeeDetails.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = "",
  E6_MS_TMS_BUSI_WEB = "",
  E6_MS_TMS_PERSONALIZE_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取司机费用上报明细表格数据
export function queryPageDriveCost(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/driverCost/queryPage`,
    method: "post",
    data
  });
}

// 导出司机费用上报明细
export function exportTotal(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/driverCost/exportTotal`,
    method: "post",
    data
  });
}
//新增
export function saveAddCost(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/driverCost/save`,
    method: "post",
    data
  });
}
//费用调整
export function saveAdjustFee(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/driverCost/feeAdjust`,
    method: "post",
    data
  });
}
//审核费用
export function saveAuditFee(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/driverCost/check`,
    method: "post",
    data
  });
}
//获取运单号下拉
export function fetchWaybillNoList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getDropBox`,
    method: "post",
    data
  });
}
//获取调整记录
export function fetchFeeRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/driverCost/feeRecord`,
    method: "post",
    data
  });
}
//查询个性配置是否配置了费用审核
export function fetchPersonalSetting(params) {
  return http({
    url: `${host}${E6_MS_TMS_PERSONALIZE_WEB}/personalSet/getCheckSet`,
    method: "get",
    params
  });
}
